<template>
  <div class="top-bar-middle">
    {{ title }}
    <a href="#" @click="share" v-if="showShare"><img
      class="artist-share-icon" src="/images/share-plane.svg" alt="Share"></a>
  </div>
</template>

<script>
import store from './sidebar_store.js'
import { mixesStore } from './path_store'
import bus from "../bus"

export default {
  methods: {
    share() {
      let shareObjectType
      let shareURL
      let shareTitle

      if ( this.playlist ) {
        shareTitle = this.playlist.name
        shareURL = `/share/playlist/${this.playlist.id}.json`
        shareObjectType = "playlist"
      } else if ( this.song ) {
        shareTitle = this.song.name
        shareURL = `/share/song/${this.song.id}.json`
        shareObjectType = "song"
      } else if ( this.artist ) {
        shareTitle = this.artist.name
        shareURL = `/share/artist/${this.artist.id}.json`
        shareObjectType = "artist"
      }


      bus.emit("open-share", {
        shareTitle: shareTitle,
        createShareURL: shareURL,
        shareObjectType: shareObjectType,
        shareChoice: false,
      })
    }
  },
  computed: {
    artist() {
      return store.artistForRoute(this.$route)
    },
    song() {
      const { songID } = this.$route.params
      return songID && store.songs.find(s => s.id == songID)
    },
    playlist() {
      const { playlistID } = this.$route.params
      return playlistID ? store.playlists.find(p => p.id == playlistID) : undefined
    },
    latestOrAll() {
      if ( this.$route.path.includes("/latest") ) {
        return "Latest Mixes"
      } else {
        return "All Mixes"
      }
    },
    title() {
      if ( this.song )  {
        return this.song.name
      } else if ( this.artist ) {
        return `${this.artist.name} - ${this.latestOrAll}`
      } else if ( this.playlist ) {
        return this.playlist.is_shared ? `Shared Playlist: ${this.playlist.name}` : `Playlist: ${this.playlist.name}`
      } else if ( this.$route.path === "/mixes/new" ) {
        return "Upload a mix"
      } else if ( this.$route.path.endsWith("/edit") && this.$route.path.startsWith("/mixes/") ) {
        const id = parseInt(this.$route.params.mixID)
        const mix = mixesStore.items.find(m => m.id === id)
        return mix ? `Editing ${mix.song_name} v${mix.version}` : "Edit Mix"
      } else if ( this.$route.path.startsWith("/mixes") ) {
        return ""
      } else {
        return this.latestOrAll
      }
    },
    showShare() {
      return this.playlist || this.song || this.artist
    }
  }
}
</script>
